import { FaWhatsapp } from 'react-icons/fa';

const FooterWithWhatsApp = () => {
  const welcomeMessage = encodeURIComponent(
    "Welcome to BizApps!\nHow can we assist you today?"
  );

  return (
    // <div className='flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 p-1 bg-gray-100'>
    <div className='flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 p-1 bg-[#B2BEB5] leading-none'  >
      <div className='text-center md:text-left text-gray-700'>
        All Rights Reserved to BizApps, Multan, Pakistan.
      </div>
      <div className='flex items-center'>
        <a
          href={`https://wa.me/923344373507?text=${welcomeMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#25D366] hover:bg-[#128C7E] rounded-full p-1 flex items-center justify-center transition-colors duration-200"
          aria-label="Contact us on WhatsApp"
        >
          <FaWhatsapp className="text-black text-xl" />
        </a>
        <span className='ml-2 text-gray-700 hover:underline hover:text-blue-600' >
          (92) 334 4373507
        </span>
      </div>
      <a
        href={`https://www.bizapps.pk`}
        target="_blank"
        rel="noopener noreferrer"
        className=" hover:bg-gray-500 hover:text-white rounded-full px-3 py-1  transition-colors duration-200"
        aria-label="Welcome to the website"
      >
        www.bizapps.pk
      </a>

    </div>
  );
};

export default FooterWithWhatsApp;